<template>
  <page-wrapper :title="title" :has-pad="true">
    <div v-if="!detail" class="text-center p-4">กำลังโหลด</div>
    <div v-else class="wrapper">
      <div class="row">
        <div class="col-3 member">
          <p
            v-if="subscriber.isUserForOfflinePurchaseByAdmin === true"
            class="font-red"
          >*ซื้อนอกระบบลูกค้าไม่โหลด App</p>
          <p>ชื่อ</p>
          <h6>{{ subscriber.name }}</h6>
          <p>บ้านเลขที่</p>
          <h6>{{ subscriber.home.addressNumber }}</h6>
          <p>โครงการ</p>
          <h6>{{ subscriber.home.project }}</h6>
          <p>เบอร์โทรศัพท์</p>
          <h6>{{ subscriber.phoneNumber }}</h6>
          <p>E-mail</p>
          <h6>{{ subscriber.email }}</h6>
          <p>เลขบัตรประชาชน / Passport No.</p>
          <div class="mb-3">
            <button
              v-if="!isButtonHidden"
              class="button-content"
              @click="handleDecryptIdCard"
            >
              <span style="font-weight: bold">แสดงข้อมูล</span>
              <i class="fa fa-eye-slash" aria-hidden="true"></i>
            </button>
            <div v-if="subscriber.identifierNo" class="identifier-id">
              {{ subscriber.identifierNo }}
            </div>
         </div>
          <p>วันเกิด</p>
          <h6>{{ subscriber.dateOfBirth }}</h6>
        </div>
        <div class="col-9 info">
          <p>แพ็กเกจ</p>
          <h6>
            {{ subscriber.package.name }}
            <br />
            <small>{{ subscriber.package.billingCycle }}</small>
            <br />
            <small>{{ subscriber.qualityText }}</small>
          </h6>
          <p>บริการ</p>
          <div v-for="(service, serviceIndex) in services" :key="serviceIndex">
            <service-list-item
              :key="service.id"
              v-bind="service.data"
              :quality-unit="subscriber.qualityUnit"
              class="service-item"
            ></service-list-item>
            <div
              v-for="(history, historyIndex) in Object.keys(service.histories)
              .sort((a, b) => (b.invoice > a.invoice ? 1 : -1))"
              :key="history">
              <p v-if="history!=='null'">
                <b>รอบบิลที่:</b> {{ Object.keys(service.histories).length - historyIndex }}
                &nbsp; Invoice: {{history.toString().padStart(12, "0")}}
                &nbsp; ซื้อเมื่อ: {{service.histories[history][0].purchasedAt | date}}
                &nbsp; มีผลเมื่อ: {{service.histories[history][0].effectivedAt | date}}
                &nbsp; เลขใบเสร็จ: {{service.histories[history][0].documentNumber}}
                </p>
                <p
                  v-if="service.histories[history][0].isDisableAppointmentByNoteInvoice"
                  class="mb-3 font-red"
                >* มีการปิดไม่ให้นัดหมายใน รอบบิล นี้</p>
              <div
                v-for="(appointment, appointmentIndex) in service.histories[history]"
                :key="appointmentIndex"
                class="align-items-center mb-3"
              >
                <div class="row appointment-title">
                  <div class="col-lg-2">นัดหมาย</div>
                  <div v-if="!appointment.canMakeAppointment" class="col-lg-3">วันที่</div>
                  <div v-if="isDotLifePackage" class="col-lg-2">สถานะ</div>
                  <div v-if="!appointment.canMakeAppointment" class="col-lg-2">ผู้ให้บริการ</div>
                  <div v-if="!appointment.canMakeAppointment" class="col-lg-2">ราคาต้นทุนจริง</div>
                </div>
                <div class="row">
                  <div class="col-lg-2">ครั้งที่ {{ (appointment.appointmentNo!==null)? appointment.appointmentNo : appointmentIndex + 1 }}</div>
                  <div v-if="!appointment.canMakeAppointment" class="d-flex flex-row col-lg-3">
                    <div class="me-1">{{ isDotLifePackage ? dotLifeOrderDate : appointment.date }}</div>
                    <div v-show="!isDotLifePackage && !isFastFixServiceType(service.data.type)">
                      - {{ appointment.time }}
                    </div>
                  </div>
                  <div v-if="isDotLifePackage" class="col-lg-2">{{ dotLifeOrderStatus }}</div>
                  <div v-if="!appointment.canMakeAppointment" class="col-lg-2">
                    <el-select
                      :value="appointment.providerId"
                      :disabled="appointment.canNotEditAppointmentCost"
                      class="provider-selector"
                      filterable
                      placeholder="เลือกผู้ให้บริการ"
                      remote
                      @input="handleChangeProvider(
                        appointment.id,
                        $event,
                        appointment.actualCost
                      )"
                    >
                      <el-option
                        v-for="item in providers"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                        <div class="provider-option">
                          <img :src="item.logoUrl" class="icon" />
                          <div class="name">{{ item.name }}</div>
                        </div>
                      </el-option>
                    </el-select>
                  </div>
                  <div v-if="!appointment.canMakeAppointment" class="col-lg-2">
                    <input
                      :disabled="appointment.canNotEditAppointmentCost"
                      :value="appointment.actualCost"
                      type="text"
                      class="form-control"
                      placeholder="Enter เพื่อบันทึก"
                      @input="handleEditActualCost(
                        service.id,
                        appointment.id,
                        $event.target.value
                      )"
                      @keyup.enter="handleEnterEditActualCost(
                        appointment.id,
                        appointment.actualCost,
                        appointment.providerId
                      )"
                    >
                  </div>
                  <div v-if="canShowFulfillButton(appointment)" class="col">
                    <sc-button
                      variant="success"
                      @click="handleClickFulfillAsCustomerButton(
                        appointment.id, service.id, history.id
                      )"
                      >ยืนยันการรับบริการแทนลูกบ้าน</sc-button
                    >
                  </div>
                  <div class="col-lg-2">
                    <sc-button
                      v-if="!appointment.canMakeAppointment"
                      :route="appointment.route"
                      variant="secondary"
                      size="sm"
                      >ดูข้อมูล</sc-button
                    >
                    <sc-button
                      v-else-if="appointment.canMakeAppointment"
                      :disabled="appointment.isDisableButton"
                      variant="primary"
                      size="sm"
                      @click="handleClickBookService(service, appointment)"
                      >นัดวัน</sc-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
    <confirm-dialog
      v-if="confirmDialog.isShow"
      :data="confirmDialog"
      @confirm="handleConfirm"
    >
      <div class="mb-3">
        <date-picker
          :value="form.dateTime"
          class="mb-2 w-100"
          @input="handleChangeDateTime"
        ></date-picker>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="label mb-2">เวลาที่เริ่ม</div>
          <el-time-picker
            :value="form.timeStart"
            class="mb-2"
            format="HH:mm"
            type="time"
            @input="handleChangeTime($event, 'START')"
          ></el-time-picker>
        </div>
        <div  class="col-6">
          <div class="label mb-2">เวลาที่สิ้นสุด (Optional)</div>
          <el-time-picker
            :value="form.timeEnd"
            class="mb-2"
            format="HH:mm"
            type="time"
            @input="handleChangeTime($event, 'END')"
          ></el-time-picker>
        </div>
      </div>
    </confirm-dialog>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import {
  Select as ElSelect,
  Option as ElOption,
  TimePicker as ElTimePicker,
  MessageBox,
} from "element-ui";
import { DateTime } from "luxon";
import { baanRueJaiClient , backendAdminClient } from "@/dependencies";
import { toLocaleTH, getDurationAppointmentTimeText } from "@/lib/dateTime";
import DatePicker from "@/lib/components/DatePicker";
import { toCamelCaseObject, existValueAndEmptyString } from "@/lib/util";
import { reversePaymentStatus, subscriptionStatus } from "@/lib/mapper";
import {
  convertBathToStangAndRoundTwoDecimal,
  convertStangToBathAndRoundTwoDecimal,
  formatCurrencyAndTwoDecimalsString
} from "@/lib/formatter";
import ServiceListItem from "../../services/components/ServiceListItem";

export default {
  components: {
    PageWrapper,
    ScButton,
    ServiceListItem,
    ElSelect,
    ElOption,
    DatePicker,
    ElTimePicker,
  },
  data() {
    const title = "รายละเอียดสมาชิก";
    const confirmDialog = {
      isShow: false,
      title: "นัดวัน",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: true
    };

    return {
      title,
      detail: null,
      subscriber: null,
      appointmentById: {},
      confirmDialog,
      form: {
        service: null,
        dateTime: null,
        timeStart: null,
        appointment: null,
        timeEnd: null
      },
      providers: [],
      isButtonHidden: false
    };
  },

  computed: {
    services() {
      return this.detail.services.map(service => {
        const {
          id,
          name,
          short_description: shortDescription,
          description,
          icon: iconUrl,
          quota,
          type,
          main_option_title: mainOption,
          extra_option_titles: extraOption
        } = service;
        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url
        };

        let appointmentsById;
        if (this.appointmentById[id]) {
          appointmentsById = this.appointmentById[id];
        } else if (quota === 0) {
          appointmentsById = [
            {
              id: `sentinel-${id}`,
              dateTime: null,
              serviceId: id,
              constraint: {
                canMakeAppointment: true
              },
              dateTimeEnd: null,
              providerId: service.provider.id,
              actualCost: null
            }
          ];
        } else {
          appointmentsById = [];
        }

        const appointments = appointmentsById.map((appointment) => {
          const ISOdateTime = DateTime.fromISO(appointment.dateTime);
          const time = getDurationAppointmentTimeText(appointment.dateTime, appointment.dateTimeEnd);

          let {isDisableAppointmentByNoteInvoice} = appointment
          if (
            this.detail.histories
            && this.detail.histories.length === 1
            && this.detail.histories[0].invoice
            && existValueAndEmptyString(
              this.detail.histories[0].invoice.is_disable_appointment_by_note_invoice
            )
            && quota === 0
          ) {
            isDisableAppointmentByNoteInvoice = this.detail
              .histories[0]
              .invoice
              .is_disable_appointment_by_note_invoice
          }

          return {
            id: appointment.id,
            invoice: appointment.invoiceId ?? null,
            purchasedAt: appointment.purchasedAt ?? null,
            effectivedAt: appointment.effectivedAt ?? null,
            documentNumber: appointment.documentNumber ?? null,
            appointmentNo: appointment.appointmentNo ?? null,
            date: toLocaleTH(ISOdateTime).toFormat("dd MMM yyyy"),
            time,
            route: !appointment.constraint.canMakeAppointment
              ? { name: "AppointmentDetailPage", params: { id: appointment.id } }
              : null,
            canMakeAppointment: appointment.constraint.canMakeAppointment,
            providerId: appointment.providerId,
            actualCost: appointment.actualCost,
            isDisableAppointmentByNoteInvoice,
            canNotEditAppointmentCost: appointment.canNotEditAppointmentCost,
            appointmentDetailsConstraint: appointment.appointmentDetailsConstraint || {}
          };
        })

        const histories = this.groupBy(appointments, "invoice");

        // enable appointment in each first appoint in each invoice
        Object.entries(histories).forEach(([invoiceKey, history]) => {
          history.sort((a, b) => (a.date < b.date) ? 1 : -1)
          history.sort((a, b) => (a.appointmentNo > b.appointmentNo) ? 1 : -1)
          histories[invoiceKey] = history.map((appointment, index) => {
            let isDisableButton
            if (appointment.isDisableAppointmentByNoteInvoice === true) {
              isDisableButton = true
            } else if (
              index === 0
              || history[index - 1].date !== 'Invalid DateTime'
            ) {
              isDisableButton = false
            } else {
              isDisableButton = true
            }
            isDisableButton = isDisableButton || this.isDisableBookServiceByDotLifeAppointment
            return { ...appointment, isDisableButton }
          })
        })

        return {
          id,
          data: {
            id,
            iconUrl,
            name,
            shortDescription,
            description,
            provider,
            quota,
            type,
            mainOption,
            extraOption
          },
          histories
        };
      });
    },
    isDisableBookServiceByDotLifeAppointment() {
      return this.isDotLifePackage && !this.hasLatestConfirmedAppointment;
    },
    isDotLifePackage() {
      return Boolean(this.detail && this.detail.dotlife_order);
    },
    dotLifeOrderDate() {
      return this.detail.dotlife_order.created_at
        ? toLocaleTH(DateTime.fromISO(this.detail.dotlife_order.created_at)).toFormat("dd MMM yyyy HH:mm")
        : "-";
    },
    dotLifeOrderStatus() {
      return this.detail.dotlife_order.status ? this.detail.dotlife_order.status : "-";
    },
    hasLatestConfirmedAppointment() {
      const latestHistory = this.detail
        && this.detail.histories
        && this.detail.histories[0];
      const latestAppointment = latestHistory
        && latestHistory.appointments
        && latestHistory.appointments[0];
      const confirmedAt = latestAppointment && latestAppointment.confirmed_at;

      return existValueAndEmptyString(confirmedAt);
    },
    isCallCenter() {
      return localStorage.getItem("adminRoleId") === "4";
    },
    showCancelAction() {
      if (this.isCallCenter) {
        return false;
      }

      return this.showCancelButton || this.showUnsubscribeButton;
    },
    showExpiredDate() {
      return this.status !== subscriptionStatus.EXPIRED;
    },
    showCancelButton() {
      return [
        subscriptionStatus.ACTIVE,
        subscriptionStatus.FREE_TRIAL
      ].includes(this.status);
    },
    showCancelledDate() {
      return [
        subscriptionStatus.CANCELLED,
        subscriptionStatus.UNSUBSCRIBED
      ].includes(this.status);
    },
    showUnsubscribeButton() {
      return subscriptionStatus.ACTIVE === this.status;
    },
    disabledUnsubscribeButton() {
      return !this.showUnsubscribeButton;
    },
    disabledCancelButton() {
      if (this.histories.length === 0) {
        return true;
      }

      const {isReceiptSigned} = this.histories[0];

      return isReceiptSigned;
    },
    alertDialog() {
      switch (this.status) {
        case subscriptionStatus.FREE_TRIAL:
          return {
            isShow: true,
            message: "ลูกบ้านทดลองใช้งาน"
          };
        case subscriptionStatus.UNSUBSCRIBED:
          return {
            isShow: true,
            message: "ลูกบ้านไม่ Sub ต่อ"
          };
        case subscriptionStatus.CANCELLED:
          return {
            isShow: false,
            message: "ยกเลิกทันที"
          };
        default:
          break;
      }

      if (this.histories.length === 0) {
        return {
          isShow: false,
          message: ""
        };
      }

      const {isReceiptSigned} = this.histories[0];

      if (!isReceiptSigned) {
        return {
          isShow: false,
          message: ""
        };
      }

      const isShow = isReceiptSigned;
      const date = this.histories[0].receiptSignedAt.toFormat(
        "dd MMM yyyy HH:mm"
      );

      const message = `ไม่สามารถ "ยกเลิกทันที" ได้ เนื่องจากออกใบเสร็จไปแล้ว เมื่อ ${date}`;
      return {
        isShow,
        message
      };
    },
    paymentStatus() {
      if (!this.payment) {
        return "กำลังโหลด";
      }

      if (this.payment === "F") {
        return "ไม่สามารถเรียกดูข้อมูลการชำระเงินได้";
      }

      return reversePaymentStatus[this.payment.status];
    },
    showPaymentStatus() {
      if (!this.status) {
        return false;
      }

      return (
        this.status !== subscriptionStatus.FREE_TRIAL && this.subscriber.invoice
      );
    },
    status() {
      if (this.detail === null) {
        return null;
      }

      const now = DateTime.utc();
      const isFreeTrial = Boolean(this.detail.trial);
      const isExpired = now > DateTime.fromISO(this.detail.expired_at).toUTC();

      const isUnsubscribed = !isFreeTrial && Boolean(this.detail.cancelled_at);
      const isCancelled = this.detail.cancelled_at === this.detail.expired_at;

      if (isCancelled) {
        return subscriptionStatus.CANCELLED;
      }

      if (isExpired) {
        return subscriptionStatus.EXPIRED;
      }

      if (isUnsubscribed) {
        return subscriptionStatus.UNSUBSCRIBED;
      }

      if (isFreeTrial) {
        return subscriptionStatus.FREE_TRIAL;
      }

      return subscriptionStatus.ACTIVE;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup(attempt = 0) {
      const MAX_RETRIES = 3;
      try {
        await this.setupData();
        await this.setupAppointments();
        await this.setupProviders();
      } catch (error) {
        const isEconnreset = error.response?.data?.message === "read ECONNRESET";
        if (isEconnreset && attempt < MAX_RETRIES) {
          await this.setup(attempt + 1);
        }
      }
    },
    async setupData() {
      const data = await this.fetchData();
      this.detail = data;

      const {id} = data;
      const userId = data.owner.user_id;
      const userName = `${data.owner.first_name} ${data.owner.last_name}`;
      const phoneNumber = data.owner.mobile_number || "-";
      const {email} = data.owner.user;
      const isUserForOfflinePurchaseByAdmin = data.owner.is_user_for_offline_purchase_by_admin;
      const identifierNo =
        data.owner.citizen_id !== ""
          ? data.owner.citizen_id
          : data.owner.passport_number;
      const dateOfBirth = toLocaleTH(
        DateTime.fromISO(data.owner.birth_date)
      ).toFormat("dd MMMM yyyy");

      const home = {
        addressNumber: data.home ? data.home.address_no : "",
        project: data.project ? data.project.project_name : ""
      };
      const billingCycle =
        data.current_package.billing_cycle > 1
          ? ` ${  data.current_package.billing_cycle.toLocaleString()  } `
          : " ";
      const cycleUnit = data.current_package.billing_cycle === 0 ? "ครั้ง" : "เดือน";
      const quality = data.quality || 1;
      const price = data.total_price !== null && data.total_price >= 0
        ? convertBathToStangAndRoundTwoDecimal(data.total_price)
        : convertBathToStangAndRoundTwoDecimal(data.current_package.price) * quality;
      const totalPriceBeforeDiscount = formatCurrencyAndTwoDecimalsString(price);

      const billingCycleText = `${totalPriceBeforeDiscount} บาท /${billingCycle} ${cycleUnit}`;
      const pack = {
        name: data.current_package.name,
        price,
        billingCycle: billingCycleText
      };
      const format = "dd MMMM yyyy HH:mm น.";
      const purchasedAt = toLocaleTH(
        DateTime.fromISO(data.purchased_at)
      ).toFormat(format);
      const expiredAt = toLocaleTH(DateTime.fromISO(data.expired_at)).toFormat(
        format
      );
      const cancelledAt = data.cancelled_at
        ? toLocaleTH(DateTime.fromISO(data.cancelled_at)).toFormat(format)
        : null;
      const invoice = data.invoice
        ? {
            id: data.invoice.id.toString().padStart(12, "0")
          }
        : undefined;
      const receipt = data.receipt
        ? {
            id: data.receipt.id.toString().padStart(12, "0"),
            signedAt: data.receipt.signed_at
              ? toLocaleTH(DateTime.fromISO(data.receipt.signed_at)).toFormat(
                  "dd MMMM yyyy HH:mm น."
                )
              : null
          }
        : null;
      const services = data.services.map(service => {
        const {
          id: serviceId,
          name,
          short_description: shortDescription,
          description,
          icon: iconUrl,
          type,
          main_option_title: mainOption,
          extra_option_titles: extraOption
        } = service;
        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url
        };

        return {
          id: serviceId,
          iconUrl,
          name,
          shortDescription,
          description,
          provider,
          type,
          mainOption,
          extraOption
        };
      });

      const effectivedAt = toLocaleTH(
        DateTime.fromISO(data.effectived_at)
      ).toFormat("dd MMMM yyyy HH:mm น.");
      const qualityText = `จำนวน ${data.quality || 1} แพ็คเกจ`;

      const subscriber = {
        id,
        userId,
        name: userName,
        phoneNumber,
        email,
        identifierNo,
        dateOfBirth,
        home,
        package: pack,
        purchasedAt,
        expiredAt,
        cancelledAt,
        effectivedAt,
        invoice,
        receipt,
        services,
        qualityText,
        qualityUnit: `จำนวน ${quality} หน่วย`,
        isUserForOfflinePurchaseByAdmin
      };

      this.subscriber = subscriber;
    },
    async setupAppointments() {
      const data = await this.fetchAppointments();
      const appoints = toCamelCaseObject(data);

      const appointments = appoints.map((appointment) => ({
          ...appointment,
          actualCost: appointment.actualCost !== null && appointment.actualCost >= 0
            ? convertBathToStangAndRoundTwoDecimal(appointment.actualCost)
            : null,
          canNotEditAppointmentCost: appointment.isGenerateSapMmReport === true
        }))

      this.appointmentById = this.groupBy(appointments, "serviceId");
    },
    async fetchData() {
      const { id } = this.$route.params;
      try {
        const response = await baanRueJaiClient.admin.subscriptions.subscribers.get(
          id
        );

        return response.data.result;
      } catch (error) {
        this.$message.error("ไม่สามารถเรียกดูข้อมูลได้ กรุณาลองใหม่");
        throw error;
      }
    },
    async fetchAppointments() {
      const { id } = this.$route.params;
      try {
        const response = await baanRueJaiClient.admin.subscriptions.subscribers.getAppointments(
          id
        );

        return response.data.result;
      } catch (error) {
        this.$message.error("ไม่สามารถเรียกดูข้อมูลได้ กรุณาลองใหม่");
        throw error;
      }
    },
    async handleClickBookService(service, appointment) {
      if (service.data.quota === 0) {
        try {
          await MessageBox.confirm(
            "คุณกำลังนัดหมาย 'สินค้า' เมื่อกดบันทึกจะ 'ปิดงาน' ให้ทันที",
            { confirmButtonText: "ตกลง", cancelButtonText: "ยกเลิก" }
          );
        } catch (e) {
          return;
        }
      }

      this.confirmDialog.isShow = true;
      this.form.service = service;
      this.form.appointment = appointment;
      this.confirmDialog.disableSubmit = false;
    },
    resetForm() {
      this.form.service = null;
      this.form.appointment = null;
      this.form.dateTime = null;
      this.form.timeStart = null;
      this.form.timeEnd = null;
    },
    async handleConfirm(isConfirm) {
      this.confirmDialog.disableSubmit = true;

      try {
        if (!isConfirm) {
          this.confirmDialog.isShow = false;
          this.resetForm();
          return;
        }

        if (!this.form.dateTime) {
          this.$message.error('โปรดเลือก วันที่');
          return;
        }

        if (!this.form.timeStart) {
          this.$message.error('โปรดเลือก เวลาที่เริ่ม');
          return;
        }

        try {
          const { dateTime, timeStart, timeEnd } = this.form;
          const { id: serviceId, quota } = this.form.service.data;
          const { id: appointmentId } = this.form.appointment;
          const { id: providerId } = this.form.service.data.provider;
          const {
            id: subscriptionId,
            home_id: homeId,
            project_id: projectId,
            owned_by: userId
          } = this.detail;

          const timeStartJsDate = timeStart instanceof DateTime
            ? timeStart.toJSDate()
            : timeStart;

          const date = dateTime.setZone("utc+7").set({
            hours: timeStartJsDate.getHours(),
            minutes: timeStartJsDate.getMinutes(),
          });

          if (quota === 0) {
            await baanRueJaiClient.admin.subscriptions.appointments.postCreate({
              dateTime: date,
              serviceId: serviceId.toString(),
              providerId: providerId.toString(),
              homeId,
              projectId,
              userId: userId.toString(),
              subscriptionId,
              dateTimeEnd: timeEnd || undefined,
              isFulfillAppointment: true
            });
          } else {
            await baanRueJaiClient.admin.subscriptions.appointments.updateEmpty(
              appointmentId,
              {
                date_time: date,
                date_time_end: timeEnd || undefined
              }
            );
          }

          await this.setupAppointments();
          this.confirmDialog.isShow = false;
          this.resetForm();
        } catch (error) {
          const errorCode = error.response && error.response.data && error.response.data.errorCode;

          if (errorCode === "PRODUCT_APPOINTMENT_ALREADY_DELIVERED") {
            // This product's delivery was already recorded (e.g. from the
            // product dashboard) — not an unexpected error. Refetch so the
            // appointment list reflects that immediately.
            this.$message.warning(error.response.data.message);

            try {
              await this.setupAppointments();
            } catch (refetchError) {
              // fetchAppointments() already surfaced its own error message.
            }
          } else {
            this.$message.error("ไม่สามารถนัดวันได้");
          }
        }
      } finally {
        this.confirmDialog.disableSubmit = false;
      }
    },
    handleChangeDateTime(dateTimeSelect) {
      if (!dateTimeSelect) {
        this.form.dateTime = null;
        this.form.timeStart = null;
        this.form.timeEnd = null;
        return
      }

      const updatedDateTime = dateTimeSelect.setZone("utc+7");
      this.form.dateTime = updatedDateTime.toUTC();

      const now = DateTime.now();
      const isMorningTime = now < now.set({ hour: 12});

      this.form.timeStart = isMorningTime
        ? updatedDateTime.set({ hour: 9 })
        : updatedDateTime.set({ hour: 13 })

      this.form.timeEnd = isMorningTime
        ? updatedDateTime.set({ hour: 12 })
        : updatedDateTime.set({ hour: 16 })
    },
    isFastFixServiceType(serviceType) {
      return serviceType === "FAST_FIX";
    },
    groupBy (xs, key) {
      const result = {};
      xs.forEach((x) => {
        const groupKey = x[key];
        if (!result[groupKey]) result[groupKey] = [];
        result[groupKey].push(x);
      });
      return result;
    },
    handleChangeTime(time, type) {
      const isStartTime = type === 'START'
      if (!time) {
        if (isStartTime) this.form.timeStart = null;
        if (!isStartTime) this.form.timeEnd = null;
      }

      if (isStartTime) {
        this.form.timeStart = time;
      } else {
        this.form.timeEnd = time;
      }
    },
    async setupProviders() {
      const providerList = await this.fetchProviders();

      this.providers = providerList.map(provider => {
        const {
          id,
          name,
          icon_url: logoUrl = "https//placehold.it/64",
          is_vat_registered: isVatRegistered
        } = provider;

        return {
          id,
          name,
          logoUrl,
          isVatRegistered
        };
      });
    },
    async fetchProviders() {
      const response = await baanRueJaiClient.admin.subscriptions.providers.list();

      return response.data.result;
    },
    async handleChangeProvider(
      appointmentId,
      newProviderId,
      actualCost
    ) {
      const newProvider = this.providers.find((provider) => provider.id === newProviderId)

      if (!newProvider) return

      try {
        await MessageBox.confirm(
          `ยืนยันการเปลี่ยนผู้ให้บริการเป็น ${newProvider.name}`,
          { confirmButtonText: "ตกลง", cancelButtonText: "ยกเลิก" }
        );
      } catch (e) {
        return;
      }

      const params = {
        actual_cost: actualCost !== null && actualCost >= 0
          ? convertStangToBathAndRoundTwoDecimal(actualCost)
          : null,
        provider_id: newProviderId
      }

      try {
        await baanRueJaiClient.admin.subscriptions.appointments.updateProviderAndActualCost(
          appointmentId,
          params
        );
      } catch(err) {
        this.$message.error('ไม่สามารถบันทึกผู้ให้บริการได้');
      }

      await this.setupAppointments();
    },
    async handleEnterEditActualCost(appointmentId, actualCost, providerId) {
      try {
        await MessageBox.confirm(
          `ต้องการเปลี่ยนราคาต้นทุนจริงเป็น ${actualCost}บาท หรือไม่`,
          { confirmButtonText: "ตกลง", cancelButtonText: "ยกเลิก" }
        );
      } catch (e) {
        return;
      }

      const params = {
        actual_cost: actualCost !== null && actualCost >= 0
          ? convertStangToBathAndRoundTwoDecimal(actualCost)
          : null,
        provider_id: +providerId
      }

      try {
        await baanRueJaiClient.admin.subscriptions.appointments.updateProviderAndActualCost(
          appointmentId,
          params
        );
      } catch(err) {
        this.$message.error('ไม่สามารถบันทึกราคาต้นทุนจริงได้');
      }

      await this.setupAppointments();
    },
    handleEditActualCost(serviceId, appointmentId, actualCost) {
      if (
        this.appointmentById
        && this.appointmentById[serviceId]
        && this.appointmentById[serviceId].length > 0
      ) {
        this.appointmentById[serviceId] = this.appointmentById[serviceId].map((appointment) =>
          appointment.id === appointmentId
            ? { ...appointment, actualCost }
            : appointment
        )
      } else {
        this.$message.error('ไม่สามารถแก้ไขต้นทุนจริงได้');
      }
    },
    async handleDecryptIdCard() {
      try {
        const { id } = this.subscriber;
        const response = await backendAdminClient.subscriber.getDecryptedIdCard(id);
        
        this.subscriber.identifierNo = response.data.result.id_card;
        this.isButtonHidden = true;
      } catch (error) {
        this.$message.error("ไม่สามารถเข้าถึงได้");
      }
    },
    async handleClickFulfillAsCustomerButton(appointmentId, serviceId, subscriptionId) {
      try {
        await MessageBox.confirm(
          "ยืนยันการได้รับบริการแทนลูกบ้าน",
          { confirmButtonText: "ตกลง", cancelButtonText: "ยกเลิก" }
        );
      } catch (e) {
        return;
      }

      const params = {
        status: "FULFILLED",
        serviceId,
        subscriptionId
      };

      try {
        await baanRueJaiClient.admin.subscriptions.appointments.update(
          appointmentId,
          params
        );

        window.location.reload();
      } catch (err) {
        if (err.response && err.response.data && err.response.data.errorCode) {
          if (err.response.data.errorCode === "EZTAX_NOT_SUCCESS_ERROR") {
            alert("มีการสร้างใบเสร็จรายครั้งแล้ว แต่ไม่สามารถส่ง eztax ได้");
          } else {
            alert(err.response.data.message);
          }
        }
      }

      
    },
    canShowFulfillButton(appointment) {
      return this.hasLatestConfirmedAppointment
        && this.isDotLifePackage
        && appointment.appointmentDetailsConstraint.canConfirmServiceComplete;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.info {
  border-left: $border;
}

.member h6,
.info h6 {
  margin-bottom: 20px;
}

.history {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: $border;

  font-size: 14px;

  .no {
    font-size: 16px;
    font-weight: bold;
  }
}

.view-receipt {
  display: inline-block;

  border-radius: $border-radius;
  border: $border;
  min-width: 0px;
  padding: 6px $space/ 2;

  font-size: 1rem;
  text-align: center;
  background: white;
  cursor: pointer;
  font-size: 14px;

  &:hover:not(:disabled) {
    border-color: $primary-color;

    text-decoration: none;

    background: #eee;
  }

  &:focus:not(:disabled) {
    outline: 0;

    border-color: $primary-color;
  }
}

.service-item {
  border-bottom: 0 !important;
}

.provider-selector {
  width: 100%;
}

.provider-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .icon {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.appointment-title {
  font-size: 13px;
  color: rgb(107, 106, 106);
}

.font-red {
  color: rgb(250, 102, 102);
}


.button-content {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  font-size: 16px;
  color: #4a4a4a;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.button-content:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
</style>
